(() => {
  const chooseVariant = (variants, values) => values.length && values.every(Boolean)
    ? variants.find(v => v.options.length === values.length && v.options.every((x, i) => x === values[i])) || null : null;
  if (typeof module !== 'undefined') { module.exports = {chooseVariant}; return; }
  if (window.__elInlineBuy) return;
  window.__elInlineBuy = true;
  const root = window.Shopify?.routes?.root || '/';
  const selectors = ['#shopify-section-template--27452442411354__tabs_collection_LEmTnK', '#shopify-section-template--27452442411354__featured_collection_w4xLwt'];
  let panel, opener, generation = 0, submitting = false;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(cents / 100);
  const close = (focus = true) => {
    if (submitting) return;
    generation++;
    panel?.remove(); panel = null;
    opener?.setAttribute('aria-expanded','false');
    if (focus) opener?.focus({preventScroll:true});
  };
  const message = text => { const target = panel?.querySelector('[data-message]'); if (target) target.textContent = text; };
  const show = async button => {
    if (submitting) return;
    if (opener === button && panel) { close(); return; }
    close(false); opener = button; const current = ++generation;
    const section = button.closest('.shopify-section');
    panel = document.createElement('section');
    panel.id = 'el-inline-buy'; panel.className = 'el-inline-buy';
    panel.setAttribute('aria-label','Schnell auswählen');
    panel.innerHTML = '<button type="button" class="el-inline-close" aria-label="Schließen">×</button><p role="status" data-message>Dein Look wird geladen …</p>';
    const rail = section.querySelector('.hdt-product-carousel') || section.querySelector('hdt-reval-items.hdt-collection-products');
    rail.insertAdjacentElement('afterend', panel);
    button.setAttribute('aria-expanded','true');
    panel.querySelector('.el-inline-close').onclick = () => close();
    panel.scrollIntoView({block:'nearest',behavior:'instant'});
    const handle = button.dataset.handle;
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
      if (!response.ok) throw new Error('load');
      const product = await response.json();
      if (current !== generation) return;
      const url = `${root}products/${encodeURIComponent(handle)}`;
      const images = product.images.slice(0,6);
      panel.innerHTML = `<button type="button" class="el-inline-close" aria-label="Schließen">×</button>
        <div class="el-inline-media"><div class="el-inline-gallery"><div class="el-inline-track" tabindex="0" aria-label="Produktbilder">${images.map(src=>`<img class="el-inline-image" src="${esc(src)}" alt="${esc(product.title)}" width="600" height="800" draggable="false">`).join('')}</div>${images.length>1?'<button type="button" class="el-inline-prev" aria-label="Vorheriges Bild">‹</button><button type="button" class="el-inline-next" aria-label="Nächstes Bild">›</button>':''}</div><div class="el-inline-thumbs">${images.map((src,i)=>`<button type="button" data-image="${esc(src)}" aria-label="Bild ${i+1}" aria-pressed="${i===0}"><img src="${esc(src)}" alt="" width="64" height="64" loading="lazy"></button>`).join('')}</div></div>
        <div class="el-inline-info"><p class="el-inline-eyebrow">DEIN LOOK. DEINE GRÖSSE.</p><h3 tabindex="-1">${esc(product.title)}</h3><p class="el-inline-price">${money(product.price)}</p>
        <form class="el-inline-form"><div class="el-inline-options">${product.options.map((o,i)=>`<fieldset data-option="${i}"><legend>${esc(/size|größe/i.test(o.name) ? 'Größe' : o.name)}</legend><div>${o.values.map(value=>{const available=product.variants.some(v=>v.available && v.options[i]===value);return `<label class="${available?'':'is-unavailable'}"><input type="radio" name="option-${i}" value="${esc(value)}" required ${available?'':'disabled'}><span>${esc(value)}${available?'':' · Ausverkauft'}</span></label>`;}).join('')}</div></fieldset>`).join('')}</div>
        <a class="el-inline-size" href="${root}pages/anleitungen" target="_blank" rel="noopener">Nägel richtig messen</a>
        <p class="el-inline-message" role="status" data-message>Bitte wähle deine Größe.</p><button class="el-inline-add" type="submit" disabled>Größe wählen</button></form>
        <a class="el-inline-details" href="${url}">Alle Produktdetails →</a></div>`;
      panel.querySelector('.el-inline-close').onclick = () => close();
      const form = panel.querySelector('form');
      const submit = form.querySelector('[type="submit"]');
      const selected = () => chooseVariant(product.variants, product.options.map((_,i)=>form.querySelector(`input[name="option-${i}"]:checked`)?.value || ''));
      const update = () => {
        const v = selected(); submit.disabled = !v?.available;
        submit.textContent = v ? (v.available ? 'In den Warenkorb' : 'Ausverkauft') : 'Größe wählen';
        message(v ? (v.available ? `${v.title} ausgewählt` : 'Diese Kombination ist ausverkauft.') : 'Bitte wähle deine Größe.');
        if(v) panel.querySelector('.el-inline-price').textContent = money(v.price);
      };
      form.addEventListener('change',update);
      if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
        form.querySelector('input').checked = true; form.querySelector('.el-inline-options').hidden = true; update();
      }
      const track = panel.querySelector('.el-inline-track');
      const thumbs = Array.from(panel.querySelectorAll('[data-image]'));
      let imageIndex = 0;
      const selectImage = index => {
        if (!images.length) return;
        imageIndex = Math.max(0,Math.min(index,images.length-1));
        track.scrollTo({left:imageIndex*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      thumbs.forEach((b,i)=>b.onclick=()=>selectImage(i));
      const previous = panel.querySelector('.el-inline-prev'), next = panel.querySelector('.el-inline-next');
      const syncGallery = () => {
        imageIndex = Math.round(track.scrollLeft/track.clientWidth);
        thumbs.forEach((x,i)=>x.setAttribute('aria-pressed',String(i===imageIndex)));
        if(previous) previous.disabled=imageIndex===0;
        if(next) next.disabled=imageIndex===images.length-1;
      };
      track.addEventListener('scroll',syncGallery,{passive:true});
      track.addEventListener('pointerdown',event=>event.stopPropagation(),{passive:true});
      track.addEventListener('touchstart',event=>event.stopPropagation(),{passive:true});
      track.addEventListener('keydown',event=>{
        if(event.key==='ArrowLeft'||event.key==='ArrowRight') {event.preventDefault();selectImage(imageIndex+(event.key==='ArrowRight'?1:-1));}
      });
      if(previous) previous.onclick=()=>selectImage(imageIndex-1);
      if(next) next.onclick=()=>selectImage(imageIndex+1);
      syncGallery();
      form.onsubmit = async event => {
        event.preventDefault(); const variant=selected();
        if(submitting || !variant?.available) return;
        submitting=true; submit.disabled=true; submit.textContent='Wird hinzugefügt …';
        form.querySelectorAll('input').forEach(x=>x.disabled=true);
        let added=false;
        try {
          const cart=document.querySelector('[ref="hdt-cart"]');
          const sectionId=cart?.getAttribute('section-id');
          const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}],...(sectionId?{sections:[sectionId]}:{}),sections_url:location.pathname})});
          const data=await response.json();
          if(!response.ok || data.status) { message(data.description || 'Dieser Artikel konnte nicht hinzugefügt werden.'); return; }
          added=true;
          const {CartAddEvent}=await import('@theme/events');
          form.dispatchEvent(new CartAddEvent({},String(variant.id),data,'open_cart_drawer','product-form-component',{itemCount:1,productId:String(product.id),sections:data.sections}));
          message(`${product.title} · ${variant.title} wurde hinzugefügt.`);
          submit.textContent='Hinzugefügt ✓';
        } catch(error) {
          message(added ? 'Hinzugefügt. Bitte öffne deinen Warenkorb.' : 'Verbindung unterbrochen. Prüfe zuerst deinen Warenkorb, bevor du es erneut versuchst.');
        } finally {
          submitting=false;
          if(added) { submit.disabled=true; }
          else { submit.textContent='Warenkorb prüfen'; submit.disabled=true; }
          form.querySelectorAll('input').forEach(x=>x.disabled=x.closest('label').classList.contains('is-unavailable'));
        }
      };
      panel.querySelector('h3').focus({preventScroll:true});
      panel.scrollIntoView({block:'nearest',behavior:'instant'});
    } catch(error) {
      if(current!==generation) return;
      message('Der Look konnte nicht geladen werden.');
      const link=document.createElement('a'); link.href=`${root}products/${encodeURIComponent(handle)}`;link.textContent='Zum Produkt →';panel.append(link);
    }
  };
  const enhance = () => selectors.forEach(selector=>document.querySelectorAll(`${selector} [aria-controls="hdt-quick-add-modal"]`).forEach(original=>{
    const card=original.closest('hdt-card-product');
    if(!card || card.querySelector('.el-inline-trigger')) return;
    const button=document.createElement('button');button.type='button';button.className='el-inline-trigger';button.textContent='Größe wählen';
    button.dataset.handle=original.getAttribute('handle');button.setAttribute('aria-expanded','false');button.setAttribute('aria-controls','el-inline-buy');
    card.append(button);original.closest('wrapp-hdt-open-modal-btn').style.display='none';
  }));
  document.addEventListener('pointerdown',event=>{if(event.target.closest('.el-inline-trigger')) event.stopPropagation();},true);
  document.addEventListener('click',event=>{
    const button=event.target.closest('.el-inline-trigger'); if(!button) return;
    event.preventDefault();event.stopImmediatePropagation();show(button);
  },true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape' && panel && !document.querySelector('dialog[open]')) close();});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',enhance,{once:true});else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();
